import 'phaser'

export const spriteMapSources = ['1-32']

export function preloadAssets(load: Phaser.Loader.LoaderPlugin) {
  loadImgs(load, spriteMapSources)
  loadSoundSprites(load, ['audioSprite1'])
  loadStevieFonts(load, ['oryx_32px', 'oryx_24px', 'oryx_16px'])
}

function loadImgs(load: Phaser.Loader.LoaderPlugin, names: string[]) {
  names.forEach((c) => {
    load.image(c, `assets/sprites/${c}.png`)
  })
}

function loadSoundSprites(load: Phaser.Loader.LoaderPlugin, names: string[]) {
  loadJson(load, names, 'assets/sounds')
}
function loadJson(
  load: Phaser.Loader.LoaderPlugin,
  names: string[],
  path: string,
) {
  names.forEach((c) => {
    load.json(c, `${path}/${c}.json`)
  })
}
function loadStevieFonts(load: Phaser.Loader.LoaderPlugin, names: string[]) {
  names.forEach((c) => {
    load.json(c + '-font-data', `assets/fonts/${c}.json`)
    load.image(c + '-font', `assets/fonts/${c}.png`)
  })
}
